import React from "react";
import "../Common/css/styles.css";
import {
    getAllUserNotifications,
    markNotificationAsRead,
} from "src/Services/notification_api";

export default function Notifications() {
    const [notifications, setNotifications] = React.useState<any[]>([]);
    const token = sessionStorage.getItem("token") || "";
    const userId = sessionStorage.getItem("userId") || "";

    const loadNotifications = async () => {
        try {
            const res = await getAllUserNotifications(userId, token);
            setNotifications(res);
        } catch {
            setNotifications([]);
        }
    };

    React.useEffect(() => {
        loadNotifications();
    }, []);

    // Single mark as read
    const handleMarkAsRead = async (id: number) => {
        const body = {
            userId: userId,
            notificationId: id,
            isRead: true,
        };

        try {
            await markNotificationAsRead(body, token);
            loadNotifications();
        } catch (error) {
            console.error(error);            
        }
    };

    return (
        <div className="common-outer">
            <div className="comman-header-outer">
                <span className="stream-title-text">Notifications</span>
            </div>

            <div className="nt-container">
                {notifications.length > 0 ? (
                    notifications
                        .sort(
                            (a, b) =>
                                new Date(b.createdAt).getTime() -
                                new Date(a.createdAt).getTime()
                        )
                        .map((n) => (
                            <div
                                key={n.id}
                                className={`nt-card ${
                                    n.isRead
                                        ? "nt-card-read"
                                        : "nt-card-unread"
                                }`}
                            >
                                <div className="nt-title-row">
                                    <div className="nt-title">{n.title}</div>

                                    {/* SINGLE MARK READ BUTTON */}
                                    {!n.isRead && (
                                        <button
                                            className="nt-read-btn"
                                            onClick={() =>
                                                handleMarkAsRead(n.notificationId)
                                            }
                                        >
                                            Mark as Read
                                        </button>
                                    )}
                                </div>

                                <div className="nt-description">
                                    {n.message}
                                </div>

                                <div className="nt-date">
                                    {n.createdAt.split("T")[0]} &nbsp;
                                    {n.createdAt
                                        .split("T")[1]
                                        .split(".")[0]}
                                </div>
                            </div>
                        ))
                ) : (
                    <p style={{ color: "#aaa" }}>No notifications found.</p>
                )}
            </div>
        </div>
    );
}
